import { render, staticRenderFns } from "./chart-slow.vue?vue&type=template&id=1b8a3805&"
import script from "./chart-slow.vue?vue&type=script&lang=ts&"
export * from "./chart-slow.vue?vue&type=script&lang=ts&"
import style0 from "./chart-slow.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports